import { replaceGovUrl } from "@/utils/joyspace";
import { processJoyspaceUrl } from "@/components/Joyspace/winOpen";
import bus from "@/utils/bus";
import { analysisLog } from "@/utils/logAnalytics";
import { AuthData } from "@/types/LocalConfig";
import { FocusSDK, isFocusEnv } from "@/utils";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { WebviewKernel } from "@/services/AppStore";

const genThirdAppUrl = (
  applicationKey: string,
  appId: string,
  accessToken: string,
  appRuntime: AppRuntimeEnv,
  options?: {
    redirectUrl?: string;
  }
  // eslint-disable-next-line max-params
) => {
  const s = new URL(`${appRuntime.meMainEntry}/passport/api/desktop/app/redirect/`);
  s.searchParams.append("applicationKey", applicationKey);
  s.searchParams.append("appKey", appId);
  s.searchParams.append("client", (!isFocusEnv() && "web") || appRuntime.registryConfig.client);
  s.searchParams.append("accessToken", accessToken);
  s.searchParams.append("teamId", appRuntime.selectedTeamId);
  if (options?.redirectUrl) {
    s.searchParams.append("redirectUrl", options.redirectUrl);
  }
  return s.toString();
};

const getThirdAppUrl = (
  applicationKey: string,
  config: AuthData,
  appRuntime: AppRuntimeEnv,
  options?: {
    redirectUrl?: string;
  }
  // eslint-disable-next-line max-params
) => {
  return genThirdAppUrl(applicationKey, config.ddAppId, config.accessToken, appRuntime, options);
};

// eslint-disable-next-line max-params
export function handleLinkClick(
  url: string,
  message?: any,
  config?: AuthData,
  appRuntime?: AppRuntimeEnv,
  history?: any,
  service?: any
) {
  // let appPin: string = message?.from.pin.replace('eopen-push_', '');
  if (!url) {
    return;
  }
  let realUrl = replaceGovUrl(url);
  realUrl = processJoyspaceUrl(realUrl);
  let applicationKey = message?.infox?.applicationKey;
  if (applicationKey) {
    realUrl = getThirdAppUrl(
      applicationKey,
      config || ({} as AuthData), // eslint-disable-line
      appRuntime || ({} as AppRuntimeEnv), // eslint-disable-line
      {
        redirectUrl: realUrl
      }
    );
  }
  if (isFocusEnv()) {
    // 打开方式：openType 0:新窗口，1:主窗口，2:外部浏览器
    if (message?.extend.openType?.toString() === "1") {
      console.log("到工作台打开应用");
      history.push({ pathname: "/third_apps" });
      setTimeout(() => {
        bus.emit("openThirdAppByNoticeCard", {
          homeUrl: realUrl,
          name: message?.extend.applicationName,
          csTelephone: "",
          omCompany: "",
          applicationKey: applicationKey,
          trustedDomains: "",
          version: message?.extend?.pcVersion || "2.0.0",
          webviewKernel: 6
        });
      }, 500);
      return;
    }
    if (message?.extend.openType?.toString() === "2") {
      FocusSDK.openUrl(realUrl);
      return;
    }
    // 获取应用信息
    if (service) {
      service.appStoreService
        .getApplication({
          applicationKey: applicationKey
        })
        .then((data: any) => {
          if (data?.application?.webviewKernel) {
            history.push({ pathname: "/third_apps" });
            setTimeout(() => {
              bus.emit("openThirdAppByNoticeCard", {
                homeUrl: realUrl,
                name: message?.extend.applicationName,
                csTelephone: "",
                omCompany: "",
                applicationKey: applicationKey,
                trustedDomains: "",
                version: message?.extend?.pcVersion || "2.0.0",
                webviewKernel: data?.application?.webviewKernel || 6
              });
            }, 500);
          }
        })
        .catch((e: any) => {
          window.open(realUrl);
        });
    } else {
      window.open(realUrl);
    }
  } else {
    window.open(realUrl, "_blank");
  }
  // const a = document.createElement("a");
  // a.href = realUrl;
  // a.setAttribute("target", "_blank");
  // a.click();
}
